import { blue, lightGreen, pink } from '@mui/material/colors'
import { createTheme, responsiveFontSizes } from '@mui/material/styles'

// A custom theme for this app
const theme = responsiveFontSizes(
  createTheme({
    cssVariables: true,
    typography: {
      fontSize: 12,
      h1: {
        fontSize: '2.5rem',
        fontFamily: 'Roboto Slab, serif',
        fontWeight: 200,
      },
      h2: {
        fontSize: '2.25rem',
        fontFamily: 'Roboto Slab, serif',
        fontWeight: 200,
      },
      h3: {
        fontSize: '2rem',
        fontFamily: 'Roboto Slab, serif',
        fontWeight: 400,
      },
      h4: {
        fontFamily: 'Roboto Slab, serif',
      },
      h5: {
        fontFamily: 'Roboto Slab, serif',
      },
      h6: {
        fontFamily: 'Roboto Slab, serif',
      },
    },
    palette: {
      primary: {
        main: lightGreen[100],
      },
      secondary: {
        main: pink.A200,
      },
    },
    components: {
      MuiFormLabel: {
        styleOverrides: {
          root: {
            '&.Mui-focused': {
              color: lightGreen[900],
            },
          },
        },
      },
      MuiInput: {
        styleOverrides: {
          root: {
            '&.Mui-focused::after': {
              borderColor: lightGreen[900],
            },
          },
        },
      },
      MuiLink: {
        styleOverrides: {
          root: {
            color: blue[500],
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          textPrimary: {
            color: lightGreen[900],
          },
          outlined: {
            borderColor: lightGreen[900],
            color: lightGreen[900],
            '&:hover': {
              borderColor: lightGreen[700],
              color: lightGreen[700],
            },
          },
        },
      },
    },
  }),
)

export default theme
